<template>
    <div>
        <first />
        <second />
        <third />
    </div>
</template>

<script src="./telecom.js"></script>
<style src="./telecom.css"></style>